import React from 'react'
import { Alert } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'
import { useRatesUnavailableInlineStyles } from './rates-unavailable-inline.styles'

/** Inline checkout warning when carriers returned no shippable rates (same `Alert` pattern as address status). */
export const RatesUnavailableInline: React.FC = (): React.ReactElement => {
  const classes = useRatesUnavailableInlineStyles()
  const { t } = useTranslation()

  return (
    <Alert
      severity="warning"
      className={classes.alert}
      role="status"
      aria-live="polite"
    >
      {t('checkout.ratesNoAvailable')}
    </Alert>
  )
}
